function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#lb_facebook_logo_svg__clip0_1599_869)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M8 0a8 8 0 100 16A8 8 0 008 0zm3.736 10.73a1 1 0 01-1 1h-1.6V9.06h.922a.164.164 0 00.162-.144l.102-.86a.164.164 0 00-.162-.182H9.128v-.72c0-.326.09-.55.558-.55h.434a.164.164 0 00.164-.164v-.72a.163.163 0 00-.101-.152.164.164 0 00-.063-.012h-.706c-.862 0-1.45.526-1.45 1.49v.832H7.27a.164.164 0 00-.164.164v.86a.164.164 0 00.164.164h.694v2.67H5.27a1 1 0 01-1-1V5.27a1 1 0 011-1h5.46a1 1 0 011 1l.006 5.46z",
  fill: "currentColor"
}));

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "lb_facebook_logo_svg__clip0_1599_869"
}, /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M0 0h16v16H0z"
})));

var SvgLbFacebookLogo = function SvgLbFacebookLogo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 16 16",
    fill: "none"
  }, props), _ref, _ref2);
};

export default SvgLbFacebookLogo;